import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { lower } from "change-case";
import ReactTable from "react-table";
import { Field } from "redux-form";
import {
  IconButton,
  Collapse,
  Card,
  CardHeader,
  CardContent,
} from "@material-ui/core";
import { ExpandMore, ExpandLess } from "@material-ui/icons";
import FieldInput, { InputType as type } from "components/SemanticForm";
import {
  getCompanies,
  getCountry,
  getBankKeys,
  getBPGroups,
  getIndustries,
  getBusinessPartners,
  getBankBranch,
} from "ducks/options";
import { GeneralInformationContainer, SubDetailContainer } from "./styled";
import { TableData } from "routes/Suppliers/Form/GeneralForm/styled";
import { options } from "../../AttributeData";
import {
  BankAccountForm,
  CompanyForm,
  EmailAndTelForm,
  LoadBPForm,
  BlockForm,
  CopyForm,
  LoadTypeEForm,
} from "..";
import { Button, Segment, Modal, Header, Icon } from "semantic-ui-react";
import { columnUser, columnBank } from "../../AttributeData";
import { getAddress } from "ducks/address";
import { isNullOrEmpty } from "core/utilities";
import { getHrmsMembers, getAllMembers } from "ducks/member";
import { showConfirmModal } from "ducks/app";
import {
  getBPCompanies,
  getBPAccountingView,
  getBPGeneralView,
} from "ducks/vendorMaintenance";
import {
  typeOfConsultant,
  typeOfContractorSubContractor,
  typeOfDesigner,
  typeOfOther,
  typeOfSupplierDealeFactory,
} from "routes/Suppliers/Form/GeneralForm/data";

const GeneralInformation = (props) => {
  const {
    valueForm,
    companies,
    countries,
    change,
    address,
    bankKeys,
    bankBranch,
    businessPartnerGroups,
    industries,
    businessPartners,
    showConfirmModal,
    vendorCompanies,
    members,
    memberLoading,
    username,
    isDisplay = false,
  } = props;
  const vendorUsers = valueForm.vendorUsers ? valueForm.vendorUsers : [];
  const vendorBanks = valueForm.vendorBanks ? valueForm.vendorBanks : [];
  const canEditVendorData = !isNullOrEmpty(valueForm.vendorType);

  const [showGeneralInfo, setShowGeneralInfo] = useState(true);
  const [showUserForm, setShowUserForm] = useState(false);
  const [userData, setUserData] = useState(undefined);
  const [showBankForm, setShowBankForm] = useState(false);
  const [bankData, setBankData] = useState(undefined);
  const [showCompanyForm, setShowCompanyForm] = useState(false);
  const [showLoadVendorForm, setShowLoadVendorForm] = useState(false);
  const [sapAddress, setSapAddress] = useState("");
  const [showMemberForm, setShowMemberForm] = useState(false);

  const [showWarningModal, setShowWarningModal] = useState(false);
  const [warningMessage, setWarningMessage] = useState("");

  useEffect(() => {
    if (!countries.data.length && !countries.loading) {
      props.getCountry();
    }

    if (!companies.data.length && !companies.loading) {
      props.getCompanies();
    }

    if (!address.data.length && !address.loading) {
      props.getAddress();
    }

    if (!bankKeys.data.length && !bankKeys.loading) {
      props.getBankKeys();
    }

    if (!businessPartnerGroups.data.length && !businessPartnerGroups.loading) {
      props.getBPGroups();
    }

    if (!industries.data.length && !industries.loading) {
      props.getIndustries();
    }

    if (!businessPartners.data.length && !businessPartners.loading) {
      props.getBusinessPartners();
    }

    if (!members.length && !memberLoading) {
      // props.getHrmsMembers()
      props.getAllMembers();
    }
  }, []);

  useEffect(() => {
    if (
      !vendorCompanies.data.length &&
      !vendorCompanies.loading &&
      valueForm.vendorCode
    ) {
      props.getBPCompanies(valueForm.vendorCode);
    }
  }, [valueForm.vendorCode]);

  const provinceOptions = address.data.map((a) => ({
    value: lower(a.nameTh),
    text: a.nameTh,
  }));

  const businessPartnerGroupOptions = () => {
    const mainDeptCode = localStorage.getItem("mainDeptCode") || "";

    const allowList = ["GRF", "CRF", "AXTHP-FIN&ACC", "ACC", "ACC01"];

    if (!allowList.includes(mainDeptCode)) {
      return businessPartnerGroups.data.filter(
        (g) => g.value !== "ZRPT" && g.value !== "ZRCP",
      );
    }

    return businessPartnerGroups.data;
  };

  const onSubmitVendorUser = (data, isNew, oldData) => {
    if (isNew) {
      change("vendorUsers", [...vendorUsers, data]);
    } else {
      const index = vendorUsers.findIndex((u) => u.email === oldData.email);
      // vendorUsers[index] = data
      change(`vendorUsers[${index}]`, data);
    }
  };

  const showModalEditUser = (userIndex) => {
    setUserData(vendorUsers[userIndex]);
    setShowUserForm(true);
  };

  const onDeleteUser = (userIndex) => {
    var clone = [...(valueForm.vendorUsers || [])];
    clone.splice(userIndex, 1);
    change("vendorUsers", [...clone]);
  };

  const onSubmitVendorBank = (data, isNew, oldData) => {
    if (isNew) {
      change("vendorBanks", [...vendorBanks, data]);
    } else {
      const { index } = data;
      if (index !== null && index !== undefined) {
        vendorBanks[index] = data;
      } else {
        const index = vendorBanks.findIndex(
          (b) => b.accountNumber === oldData.accountNumber,
        );
        vendorBanks[index] = data;
      }

      change("vendorBanks", [...vendorBanks]);
    }
  };

  const showModalEditBank = (userIndex) => {
    setBankData({ ...vendorBanks[userIndex], index: userIndex });
    setShowBankForm(true);
  };

  const onDeleteBank = (userIndex) => {
    var clone = [...(valueForm.vendorBanks || [])];
    clone.splice(userIndex, 1);
    change(`vendorBanks`, [...clone]);
  };

  const distinctOptions = (province) => {
    const provinceOption = address.data.find(
      (d) => d.nameTh === (province || valueForm.province),
    );

    if (provinceOption) {
      return provinceOption.districts.map((a) => ({
        value: lower(a.nameTh),
        text: a.nameTh,
      }));
    }

    return [];
  };

  const subDistinctOptions = (province, district) => {
    const provinceOption = address.data.find(
      (d) => d.nameTh === (province || valueForm.province),
    );

    if (provinceOption) {
      const districtOption = provinceOption.districts.find(
        (d) => d.nameTh === (district || valueForm.district),
      );
      if (districtOption) {
        return districtOption.subDistricts.map((a) => ({
          value: lower(a.nameTh),
          text: a.nameTh,
          code: a.zipCode,
        }));
      }
    }

    return [];
  };

  const onChangePurpose = (value) => {
    change("vendorCode", "");
    change("companyCode", "");
    change("accountGroup", "");
    change("vendorType", "");
    change("vendorName1", "");
    change("vendorName2", "");
    change("vendorName3", "");
    change("vendorName4", "");
    change("searchName", "");
    change("industry", "");
    change("standardIndustry", true);
    change("taxId", "");
    change("country", "");
    change("province", "");
    change("district", "");
    change("subDistrict", "");
    change("postalCode", "");
    change("houseNumber", "");
    change("buildingOrRoomNo", "");
    change("street", "");
    change("vendorUsers", []);
    change("vendorBanks", []);

    if (value === "change" || value === "block" || value === "copy") {
      change("paymentMethod", []);
      change("paymentTypeTransfer", false);
      change("paymentTypeCheque", false);
      change("paymentTypeTtlc", false);
    }

    if (value === "block" || value === "copy") {
      change("paymentMethod", []);
      change("paymentTypeTransfer", false);
      change("paymentTypeCheque", false);
      change("paymentTypeTtlc", false);

      // Clear copy value
      change("copyType", "");
      change("companies", []);
      change("copyPurchasingOrg", []);
      change("branchCode", "");
      change("branchDescription", "");
    }
  };

  const onChangeAccountGroup = (value) => {
    if (["ZDOV", "ZFOV", "ZRPT", "ZRCP", "ZOTV"].includes(value)) {
      change("usePurchasingView", true);
    } else {
      change("usePurchasingView", false);
      change("purchasingOrg", "");
      change("orderCurrency", "");
      change("paymentTerms", "");
      change("salePerson", "");
      change("salePersonTelephone", "");
      change("incoterm", "");
      change("incotermsLocation", "");
      change("grBasedInvoiceVerification", false);
    }

    if (["ZDOV", "ZRPT", "ZRCP", "ZOTV"].includes(value)) {
      change("grBasedInvoiceVerification", true);
    } else {
      change("grBasedInvoiceVerification", false);
    }

    if (value === "ZFIN" || value === "ZRPT" || value === "ZRCP") {
      change("vendorType", "company");
    }

    if (value === "ZEMP") {
      change("vendorType", "personal");
      if (valueForm.purpose === "create") {
        change("industry", "Z001");
      }
    }

    // Default Accounting Information
    if (value === "ZDOV") {
      change("planningGroup", "V1");
      change("reconciliationAccount", "23000010");
      change("sortKey", "002");
    } else if (value === "ZFOV") {
      change("planningGroup", "V2");
      change("reconciliationAccount", "26400000");
      change("sortKey", "002");
    } else if (value === "ZRPT" || value === "ZRCP") {
      change("planningGroup", "V3");
      change("reconciliationAccount", "23001010");
      change("sortKey", "002");
    } else {
      change("planningGroup", "V1");
      change("reconciliationAccount", "26400000");
      change("sortKey", "002");
    }

    //Is Government
    if (["ZDOV", "ZFOV", "ZOTV"].includes(value)) {
      if (valueForm.vendorType === "company") {
        //
      } else {
        change("isGovernment", null);
      }
    } else {
      change("isGovernment", null);
    }
  };

  const getBoolValue = (value, defaultValue) => {
    return value !== undefined && value !== null && value !== ""
      ? value
      : defaultValue;
  };

  const onLoadBusinessPartnerSuccess = (data) => {
    setShowLoadVendorForm(false);

    change("vendorCode", data.vendorCode || "");
    change("companyCode", data.companyCode || "");
    change("accountGroup", data.accountGroup || "");
    change("vendorType", data.vendorType || "");
    change("vendorName1", data.vendorName1 || "");
    change("vendorName2", data.vendorName2 || "");
    change("vendorName3", data.vendorName3 || "");
    change("vendorName4", data.vendorName4 || "");
    change("searchName", data.searchName || "");
    change("industry", data.industry || "");
    change("standardIndustry", getBoolValue(data.standardIndustry, true));
    change("taxId", data.taxId || "");
    change("isGovernment", data.isGovernment || false);
    change("country", data.country || "");
    change("province", data.province || "");
    change("district", data.district || "");
    change("subDistrict", data.subDistrict || "");
    change("postalCode", data.postalCode || "");
    change("houseNumber", data.houseNumber || "");
    change("buildingOrRoomNo", data.buildingOrRoomNo || "");
    change("street", data.street || "");
    change("vendorUsers", [...(data.users || [])]);
    change("vendorBanks", [...(data.banks || [])]);

    change("branchCode", "");
    change("branchDescription", "");

    // Clear copy value
    change("companies", []);
    change("copyPurchasingOrg", []);

    var address = data.houseNumber ? data.houseNumber : "";
    address =
      address + (data.buildingOrRoomNo ? ` ${data.buildingOrRoomNo}` : "");
    address = address + (data.street ? ` ${data.street}` : "");
    address = address + (data.subDistrict ? ` ${data.subDistrict}` : "");
    address = address + (data.district ? ` ${data.district}` : "");
    address = address + (data.province ? ` ${data.province}` : "");
    address = address + (data.postalCode ? ` ${data.postalCode}` : "");
    address = address.replace("  ", " ").trim();
    setSapAddress(address);

    if (data.accountGroup === "ZEMP" || (data.banks || []).length > 0) {
      change("paymentTypeTransfer", true);
    }
    change("receiveEWht", data.receiveEWht);

    if (data.country === "TH")
      checkAddressOption(data.province, data.district, data.subDistrict);
  };

  const checkAddressOption = (province, district, subDistrict) => {
    let provinceOpt = provinceOptions.find((p) => p.value === province);
    if (provinceOpt) {
      let distinctOpt = distinctOptions(province).find(
        (d) => d.value === district,
      );
      if (distinctOpt) {
        let subDistinctOpt = subDistinctOptions(province, district);
        if (subDistinctOpt) {
          // DO NOTHING.
        } else {
          change("subDistrict", "");
        }
      } else {
        change("district", "");
        change("subDistrict", "");
      }
    } else {
      change("province", "");
      change("district", "");
      change("subDistrict", "");
    }
  };

  const onLoadTypeESuccess = (data) => {
    setShowMemberForm(false);

    change("companyCode", data.companyCode || "");
    change("accountGroup", data.accountGroup || "");
    change("vendorType", "personal");
    change("vendorName3", data.vendorName3 || "");
    change("vendorName4", data.vendorName4 || "");
    change("searchName", data.searchName || "");
    change("industry", data.industry || "Z001");
    change("standardIndustry", getBoolValue(data.standardIndustry, true));
    change("taxId", data.taxId || "");
    change("country", data.country || "");
    change("province", data.province || "");
    change("district", data.district || "");
    change("subDistrict", data.subDistrict || "");
    change("postalCode", data.postalCode || "");
    change("houseNumber", data.houseNumber || "");
    change("buildingOrRoomNo", data.buildingOrRoomNo || "");
    change("street", data.street || "");
    change("vendorBanks", [...(data.banks || [])]);

    if ((data.vendorName1 || "").length > 0) {
      if ((data.vendorName2 || "").length === 0) {
        var name = `เงินสดย่อย (${data.vendorName1})`;

        if (name.length <= 40) {
          change("vendorName1", name);
          change("vendorName2", "");
        } else {
          if (data.vendorName1.includes(" ")) {
            let firstname = data.vendorName1.split(" ")[0];
            let lastname = data.vendorName1.replace(firstname, "").trim();
            change("vendorName1", `เงินสดย่อย (${firstname}`);
            change("vendorName2", `${lastname})`);
          } else {
            change("vendorName1", name);
            change("vendorName2", "");
          }
        }
      } else {
        var name2 = `เงินสดย่อย (${data.vendorName1} ${data.vendorName2})`;

        if (name2.length <= 40) {
          change("vendorName1", name2);
          change("vendorName2", "");
        } else {
          change("vendorName1", `เงินสดย่อย (${data.vendorName1}`);
          change("vendorName2", `${data.vendorName2})`);
        }
      }
    } else {
      change("vendorName1", data.vendorName1 || "");
      change("vendorName2", data.vendorName2 || "");
    }

    if ((data.users || []).length === 1) {
      if (data.users[0].firstname === "" || data.users[0].lastname === "") {
        if ((data.vendorName2 || "").length === 0) {
          if (data.vendorName1.includes(" ")) {
            let firstname = data.vendorName1.split(" ")[0];
            let lastname = data.vendorName1.replace(firstname, "").trim();

            data.users[0].firstname = firstname;
            data.users[0].lastname = lastname;
          } else {
            data.users[0].firstname = data.vendorName1 || "";
          }
        } else {
          data.users[0].firstname = data.vendorName1;
          data.users[0].lastname = data.vendorName2;
        }
      }
    }
    change("vendorUsers", [...(data.users || [])]);

    change("branchCode", "");
    change("branchDescription", "");

    // Clear copy value
    change("companies", []);
    change("copyPurchasingOrg", []);

    var address = data.houseNumber ? data.houseNumber : "";
    address =
      address + (data.buildingOrRoomNo ? ` ${data.buildingOrRoomNo}` : "");
    address = address + (data.street ? ` ${data.street}` : "");
    address = address + (data.subDistrict ? ` ${data.subDistrict}` : "");
    address = address + (data.district ? ` ${data.district}` : "");
    address = address + (data.province ? ` ${data.province}` : "");
    address = address + (data.postalCode ? ` ${data.postalCode}` : "");
    address = address.replace("  ", " ").trim();
    setSapAddress(address);

    if (data.country === "TH")
      checkAddressOption(data.province, data.district, data.subDistrict);

    if (data.vendorCode && data.companyCode) {
      props.getBPAccountingView(data.vendorCode, data.companyCode, (data) => {
        const getBoolValue = (value, defaultValue) => {
          return value !== undefined && value !== null && value !== ""
            ? value
            : defaultValue;
        };

        change("reconciliationAccount", data.reconciliationAccount || "");
        change("sortKey", data.sortKey || "");
        change("planningGroup", data.planningGroup || "");
        change("accPaymentTerms", data.accPaymentTerms || "");
        change("paymentMethod", ["C", "E", "T", "P", "B", "K"]);
        change("paymentBlock", data.paymentBlock || "");
        change("tradingPartner", data.tradingPartner || "");
        change("previousAccount", data.previousAccount || "");
        change(
          "checkDoubleInvoice",
          getBoolValue(data.checkDoubleInvoice, false),
        );
        change("payeeInDocument", getBoolValue(data.payeeInDocument, false));
        change("withholdingTaxs", [...(data.withholdingTaxs || [])]);
        change("branchCode", data.branchCode || "");
        change("branchDescription", data.branchDescription || "");
        change("accountingViewLoaded", true);
      });
    }
  };

  const onLoadBusinessPartnerWarning = (message) => {
    setWarningMessage(message);
    setShowWarningModal(true);
  };

  const renderVendorInputWithLoadButton = (props) => {
    return (
      <div style={{ display: "flex", flex: 1, marginRight: "15px" }}>
        {valueForm.vendorCode ? (
          <FieldInput {...props} containerStyle={{ marginRight: "unset" }} />
        ) : null}
        {isDisplay || valueForm.status === 5 ? null : (
          <div style={{ display: "flex", alignItems: "center" }}>
            <Button
              color="blue"
              content={
                valueForm.vendorCode ? "Change" : "Load Business Partner"
              }
              type="button"
              style={valueForm.vendorCode ? { marginLeft: "15px" } : {}}
              onClick={() => setShowLoadVendorForm(true)}
            />
          </div>
        )}
      </div>
    );
  };

  const editableForm = () => {
    if (
      valueForm.status !== 0 &&
      valueForm.status !== undefined &&
      valueForm.status !== null
    ) {
      return (
        !isDisplay &&
        valueForm.sn !== undefined &&
        valueForm.sn !== null &&
        valueForm.sn !== ""
      );
    } else {
      return !isDisplay;
    }
  };

  const editable = () => {
    return (
      editableForm() &&
      (valueForm.purpose === "create" || valueForm.purpose === "change")
    );
  };

  const beforeCountryChange = (valueForm) => (props) => {
    const checkAddressValueIsNotEmpty = () => {
      var isNotEmpty = false;
      const {
        province,
        district,
        subDistrict,
        postalCode,
        houseNumber,
        buildingOrRoomNo,
        street,
      } = valueForm;

      if (province !== undefined && province !== "" && province !== null)
        isNotEmpty = true;
      if (district !== undefined && district !== "" && district !== null)
        isNotEmpty = true;
      if (
        subDistrict !== undefined &&
        subDistrict !== "" &&
        subDistrict !== null
      )
        isNotEmpty = true;
      if (postalCode !== undefined && postalCode !== "" && postalCode !== null)
        isNotEmpty = true;
      if (
        houseNumber !== undefined &&
        houseNumber !== "" &&
        houseNumber !== null
      )
        isNotEmpty = true;
      if (
        buildingOrRoomNo !== undefined &&
        buildingOrRoomNo !== "" &&
        buildingOrRoomNo !== null
      )
        isNotEmpty = true;
      if (street !== undefined && street !== "" && street !== null)
        isNotEmpty = true;

      return isNotEmpty;
    };

    if (
      valueForm.country &&
      valueForm.country !== props.value &&
      checkAddressValueIsNotEmpty()
    ) {
      showConfirmModal(true, {
        header: "Are you sure you want to change the country?",
        message: (
          <React.Fragment>
            {"The address information will be deleted immediately."}
          </React.Fragment>
        ),
        btnConfirmText: "Yes",
        onClickConfirm: () => {
          props.onChange();
          if (props.specialOnChange) props.specialOnChange();
          change("province", "");
          change("district", "");
          change("subDistrict", "");
          change("postalCode", "");
          change("houseNumber", "");
          change("buildingOrRoomNo", "");
          change("street", "");
        },
        btnCancelText: "No",
        onClickCancel: () => {
          props.clearSearchText();
        },
      });
    } else {
      props.onChange();
      if (props.specialOnChange) props.specialOnChange();
    }
  };

  const companyFieldIsEditable = () => {
    if (valueForm.purpose === "create") {
      return editableForm();
    } else if (valueForm.purpose === "change") {
      if (valueForm.vendorCode) {
        if (vendorCompanies.data.length === 0) {
          return editableForm();
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const setTypeOfBusiness = () => {
    let result = [];
    if (valueForm && valueForm.typeOfVendor) {
      if (valueForm.typeOfVendor.Consultant) {
        result.push(...typeOfConsultant);
      }
      if (valueForm.typeOfVendor.Designer) {
        result.push(...typeOfDesigner);
      }
      if (valueForm.typeOfVendor.ContractorSubContractor) {
        result.push(...typeOfContractorSubContractor);
      }
      if (
        valueForm.typeOfVendor.SupplierDealer ||
        valueForm.typeOfVendor.Factory
      ) {
        result.push(...typeOfSupplierDealeFactory);
      }
      if (valueForm.typeOfVendor.Other) {
        result.push(...typeOfOther);
      }
    }
    return result;
  };

  const showLoadZempButton = () => {
    var checkValueForm =
      canEditVendorData &&
      editable() &&
      valueForm.accountGroup === "ZEMP" &&
      valueForm.purpose === "create";

    if (checkValueForm) {
      if (username) {
        var member = members.find((m) => m.username === username);
        if (member !== undefined && member !== null) {
          if (member.employeeCode) {
            var code = `E${member.employeeCode}`;
            if (businessPartners.data.find((b) => b.value === code)) {
              return { vendorCode: code, companyCode: member.companyCode };
            }
          }
        }
      }
    }

    return null;
  };

  const LoadZempData = () => {
    const data = showLoadZempButton();
    props.getBPGeneralView(
      data.vendorCode,
      data.companyCode,
      onLoadTypeESuccess,
      onLoadBusinessPartnerWarning,
    );
  };

  const censorData = () => {
    let mainDeptCode = localStorage.getItem("mainDeptCode") || "";

    if (valueForm.accountGroup === "ZEMP") {
      if (
        valueForm.createdBy === username ||
        valueForm.requesterUser === username ||
        (mainDeptCode === "GRF" || mainDeptCode === "ACC")
      ) {
        return false;
      }
      return true;
    } else {
      return false;
    }
  };

  return (
    <React.Fragment>
      <Card style={{ marginTop: "10px" }}>
        <CardHeader
          title="General Information"
          action={
            <IconButton
              aria-label="Expand"
              onClick={() => setShowGeneralInfo(!showGeneralInfo)}
            >
              {showGeneralInfo ? <ExpandLess /> : <ExpandMore />}
            </IconButton>
          }
        />
        <Collapse in={showGeneralInfo}>
          <CardContent>
            <GeneralInformationContainer>
              <div className="rowFields">
                <Field
                  name="purpose"
                  label="Purpose"
                  require
                  type={type.select}
                  editable={editableForm() && valueForm.status === undefined}
                  options={options.purpose}
                  specialOnChange={(value) => onChangePurpose(value)}
                  component={FieldInput}
                />
                {!valueForm.purpose || valueForm.purpose === "create" ? (
                  <Field
                    name="vendorCode"
                    label="Business Partner Number"
                    editable={false}
                    require={false}
                    type={type.text}
                    component={FieldInput}
                  />
                ) : (
                  <Field
                    name="vendorCode"
                    label="Business Partner Number"
                    require
                    editable={false}
                    containerStyle={{ marginRight: "10px" }}
                    type={type.text}
                    component={renderVendorInputWithLoadButton}
                  />
                )}
              </div>
              <div className="rowFields">
                <Field
                  name="accountGroup"
                  label="Account Group"
                  require
                  editable={
                    valueForm.purpose === "create" &&
                    editableForm() &&
                    (valueForm.status === undefined || valueForm.status === 0)
                  }
                  type={type.select}
                  options={businessPartnerGroupOptions()}
                  specialOnChange={(value) => onChangeAccountGroup(value)}
                  component={FieldInput}
                />
                {valueForm.purpose === "copy" ? (
                  <Field
                    name="empty"
                    label=""
                    type={type.empty}
                    component={FieldInput}
                  />
                ) : (
                  <Field
                    name="companyCode"
                    label="Company"
                    require
                    editable={companyFieldIsEditable()}
                    loading={companies.loading}
                    options={companies.data}
                    specialOnChange={(value) => {
                      var company = companies.data.find(
                        (c) => c.value === value,
                      );
                      if (company) {
                        var companyName = company.text.replace(
                          `${value} : `,
                          "",
                        );
                        change("companyName", companyName);
                      }
                    }}
                    type={type.select}
                    component={FieldInput}
                  />
                )}
              </div>
              {valueForm.purpose === "copy" && valueForm.vendorCode ? (
                <CopyForm
                  valueForm={valueForm}
                  change={change}
                  setShowCompanyForm={setShowCompanyForm}
                  companies={companies}
                />
              ) : null}
              {valueForm.purpose === "block" && valueForm.vendorCode ? (
                <BlockForm change={change} />
              ) : null}
              <SubDetailContainer>
                <div className="subTitle">Name and Address</div>
                <div className="rowFields">
                  <Field
                    name="vendorType"
                    label="Type"
                    require
                    editable={
                      editable() &&
                      valueForm.accountGroup !== "ZFIN" &&
                      valueForm.accountGroup !== "ZEMP" &&
                      valueForm.accountGroup !== "ZRPT" &&
                      valueForm.accountGroup !== "ZRCP"
                    }
                    options={options.vendorType}
                    type={type.radio}
                    specialOnChange={(value) => {
                      if (valueForm.vendorType === "company") {
                        if (
                          ["ZDOV", "ZFOV", "ZOTV"].includes(
                            valueForm.accountGroup,
                          )
                        ) {
                        } else {
                          change("isGovernment", null);
                        }
                      } else {
                        change("isGovernment", null);
                      }
                    }}
                    component={FieldInput}
                  />
                </div>
                {showLoadZempButton() ? (
                  <div className="rowFields">
                    <Button
                      color="blue"
                      content="Load your information"
                      type="button"
                      style={valueForm.vendorCode ? { marginLeft: "15px" } : {}}
                      onClick={() => LoadZempData()}
                    />
                  </div>
                ) : null}
                <div className="rowFields">
                  <Field
                    name="vendorName1"
                    label="Vendor Name"
                    require
                    placeHolder={
                      valueForm.accountGroup === "ZEMP"
                        ? "เงินสดย่อย (ชื่อ นามสกุล)"
                        : valueForm.vendorType === "personal"
                          ? "กรุณาระบุคำนำหน้า ชื่อ และนามสกุล ตามบัตรประชาชนหรือหนังสือเดินทาง เช่น น.ส. อภิศรา รุ่งเรือง"
                          : "กรุณาระบุคำนำหน้าบริษัทและชื่อบริษัท บจก. , หจก. , บมจ. เช่น บจก. ทีเอชเอส"
                    }
                    editable={canEditVendorData && editable()}
                    type={type.text}
                    component={FieldInput}
                  />
                  <Field
                    name="searchName"
                    label="Search Vendor Name"
                    require
                    placeHolder="กรุณาระบุคำสำหรับใช้ค้นหาชื่อ"
                    editable={canEditVendorData && editable()}
                    type={type.text}
                    component={FieldInput}
                  />
                </div>
                <div className="rowFields">
                  <Field
                    name="vendorName2"
                    label=""
                    type={type.text}
                    placeHolder={
                      valueForm.accountGroup === "ZEMP"
                        ? "สำรองชื่อเงินสดย่อย"
                        : "สำรองชื่อ Vendor Name"
                    }
                    editable={canEditVendorData && editable()}
                    component={FieldInput}
                  />
                  <Field
                    name="empty"
                    label=""
                    type={type.empty}
                    component={FieldInput}
                  />
                </div>
                {valueForm.accountGroup === "ZEMP" ? null : (
                  <React.Fragment>
                    <div className="rowFields">
                      <Field
                        name="vendorName3"
                        label=""
                        type={type.text}
                        placeHolder="สำรองชื่อ Vendor Name"
                        editable={canEditVendorData && editable()}
                        component={FieldInput}
                      />
                      <Field
                        name="empty"
                        label=""
                        type={type.empty}
                        component={FieldInput}
                      />
                    </div>
                    <div className="rowFields">
                      <Field
                        name="vendorName4"
                        label=""
                        type={type.text}
                        placeHolder="สำรองชื่อ Vendor Name"
                        editable={canEditVendorData && editable()}
                        component={FieldInput}
                      />
                      <Field
                        name="empty"
                        label=""
                        type={type.empty}
                        component={FieldInput}
                      />
                    </div>
                  </React.Fragment>
                )}
                {censorData() ? null : (
                  <React.Fragment>
                    <div className="rowFields">
                      <Field
                        name="industry"
                        label="Industry"
                        type={type.select}
                        require
                        loading={industries.loading}
                        options={industries.data}
                        editable={canEditVendorData && editable()}
                        component={FieldInput}
                      />
                      <Field
                        name="standardIndustry"
                        label="Standard Industry"
                        type={type.checkbox}
                        editable={false}
                        fieldInputStyle={{ justifyContent: "center" }}
                        component={FieldInput}
                      />
                    </div>
                    <div className="rowFields">
                      <Field
                        name="taxId"
                        label={
                          valueForm.vendorType === "personal"
                            ? "Tax ID Personal/Passport No."
                            : "Tax ID Legal Entity/Company"
                        }
                        require={valueForm.accountGroup !== "ZFOV"}
                        editable={canEditVendorData && editable()}
                        type={type.text}
                        censor
                        component={FieldInput}
                      />
                      {["ZDOV", "ZFOV", "ZOTV"].includes(
                        valueForm.accountGroup,
                      ) && valueForm.vendorType === "company" ? (
                        <Field
                          name="isGovernment"
                          label="Is Government"
                          type={type.checkbox}
                          editable={canEditVendorData && editable()}
                          fieldInputStyle={{ justifyContent: "center" }}
                          component={FieldInput}
                        />
                      ) : (
                        <Field
                          name="empty"
                          label=""
                          type={type.empty}
                          component={FieldInput}
                        />
                      )}
                    </div>
                    <div className="rowFields">
                      <Field
                        name="country"
                        label="Country"
                        require
                        type={type.select}
                        options={countries.data}
                        loading={countries.loading}
                        component={FieldInput}
                        editable={canEditVendorData && editable()}
                        beforeOnChange={beforeCountryChange(valueForm)}
                        specialOnChange={(value) => {
                          if (value === "TH") {
                            change("province", "");
                            change("district", "");
                            change("subDistrict", "");
                            change("postalCode", "");
                          }
                        }}
                      />
                      <Field
                        name="province"
                        label="Province/City"
                        require
                        type={
                          valueForm.country === "TH" ? type.select : type.text
                        }
                        options={provinceOptions}
                        loading={
                          valueForm.country === "TH" ? address.loading : false
                        }
                        component={FieldInput}
                        editable={canEditVendorData && editable()}
                        specialOnChange={() => {
                          if (valueForm.country === "TH") {
                            change("district", "");
                            change("subDistrict", "");
                            change("postalCode", "");
                          }
                        }}
                      />
                    </div>
                    <div className="rowFields">
                      <Field
                        name="district"
                        label="District"
                        require
                        type={
                          valueForm.country === "TH" ? type.select : type.text
                        }
                        options={distinctOptions()}
                        specialOnChange={() => {
                          if (valueForm.country === "TH") {
                            change("subDistrict", "");
                            change("postalCode", "");
                          }
                        }}
                        editable={canEditVendorData && editable()}
                        noResultsMessage={
                          valueForm.country === "TH" &&
                          (valueForm.province === undefined ||
                            valueForm.province === "" ||
                            valueForm.province === null)
                            ? "Please Select Province/City before District"
                            : undefined
                        }
                        component={FieldInput}
                      />
                      <Field
                        name="subDistrict"
                        label="Sub-district"
                        require
                        type={
                          valueForm.country === "TH" ? type.select : type.text
                        }
                        options={subDistinctOptions()}
                        specialOnChange={(value) => {
                          if (valueForm.country === "TH") {
                            var subDistrictOpts = subDistinctOptions();
                            var subDistrict = subDistrictOpts.find(
                              (s) => s.value === value,
                            );
                            if (subDistrict) {
                              change("postalCode", `${subDistrict.code}` || "");
                            }
                          }
                        }}
                        editable={canEditVendorData && editable()}
                        noResultsMessage={
                          valueForm.country === "TH" &&
                          (valueForm.district === undefined ||
                            valueForm.district === "" ||
                            valueForm.district === null)
                            ? "Please Select District before Sub-District"
                            : undefined
                        }
                        component={FieldInput}
                      />
                    </div>
                    <div className="rowFields">
                      <Field
                        name="houseNumber"
                        label="House Number"
                        require
                        placeHolder="กรุณาระบุ เลขที่บ้าน / เลขที่อาคาร"
                        editable={canEditVendorData && editable()}
                        type={type.text}
                        component={FieldInput}
                      />
                      <Field
                        name="buildingOrRoomNo"
                        label="Room Number/Village/Moo/Building/Floor/Street(1)"
                        require
                        editable={canEditVendorData && editable()}
                        placeHolder="กรุณาระบุ เลขที่ห้อง / หมูบ้าน / อาคาร / ชั้น / ซอย / ถนน"
                        type={type.text}
                        component={FieldInput}
                      />
                    </div>
                    <div className="rowFields">
                      <Field
                        name="street"
                        label="Street(2)"
                        editable={canEditVendorData && editable()}
                        placeHolder={isDisplay ? "" : "กรุณาระบุ ซอย / ถนน"}
                        type={type.text}
                        component={FieldInput}
                      />
                      <Field
                        name="postalCode"
                        label="Postal Code"
                        require
                        editable={canEditVendorData && editable()}
                        type={type.text}
                        component={FieldInput}
                      />
                    </div>
                    {(valueForm.purpose === "change" &&
                      valueForm.vendorCode &&
                      sapAddress) ||
                    (valueForm.purpose === "create" &&
                      valueForm.accountGroup === "ZEMP" &&
                      sapAddress) ? (
                      <div className="rowFields">
                        <Segment
                          style={{ width: "100%", background: "#EFEFEF" }}
                        >
                          <b>Address : </b>
                          {sapAddress}
                        </Segment>
                      </div>
                    ) : null}
                    {valueForm.isFromVendor ? (
                      <React.Fragment>
                        <div className="rowFields">
                          <Field
                            name="mobile"
                            label="Mobile"
                            editable={canEditVendorData && editable()}
                            type={type.text}
                            component={FieldInput}
                          />
                          <Field
                            name="telephone"
                            label="Telephone"
                            require
                            editable={canEditVendorData && editable()}
                            type={type.text}
                            component={FieldInput}
                          />
                        </div>
                        <div className="rowFields">
                          <Field
                            name="extension"
                            label="Extension"
                            require
                            editable={canEditVendorData && editable()}
                            type={type.text}
                            component={FieldInput}
                          />
                          <Field
                            name="website"
                            label="Website"
                            editable={canEditVendorData && editable()}
                            type={type.text}
                            component={FieldInput}
                          />
                        </div>
                        <div className="fieldHeader">
                          {/* <div className='headerText'>Type of Vendor <span className='require'>*</span></div> */}
                          <Field
                            name="typeOfVendor"
                            label="Type of Vendor"
                            type={type.text}
                            component={FieldInput}
                            editable={canEditVendorData && editable()}
                            className={"halfRow"}
                            dummy
                          />
                          <div className="fieldsCheckBox">
                            <Field
                              name="typeOfVendor.Consultant"
                              label="Consultant"
                              type={type.checkbox}
                              component={FieldInput}
                              editable={canEditVendorData && editable()}
                              style={{ flex: "none" }}
                            />
                            <Field
                              name="typeOfVendor.Designer"
                              label="Designer"
                              type={type.checkbox}
                              component={FieldInput}
                              editable={canEditVendorData && editable()}
                              style={{ flex: "none" }}
                            />
                            <Field
                              name="typeOfVendor.ContractorSubContractor"
                              label="Contractor / Sub-Contractor"
                              type={type.checkbox}
                              component={FieldInput}
                              editable={canEditVendorData && editable()}
                              style={{ flex: "none" }}
                            />
                            <Field
                              name="typeOfVendor.SupplierDealer"
                              label="Supplier / Dealer"
                              type={type.checkbox}
                              component={FieldInput}
                              editable={canEditVendorData && editable()}
                              style={{ flex: "none" }}
                            />
                            <Field
                              name="typeOfVendor.Factory"
                              label="Factory"
                              type={type.checkbox}
                              component={FieldInput}
                              editable={canEditVendorData && editable()}
                              style={{ flex: "none" }}
                            />
                            <Field
                              name="typeOfVendor.Other"
                              label="Other"
                              type={type.checkbox}
                              component={FieldInput}
                              editable={canEditVendorData && editable()}
                              style={{ flex: "none" }}
                            />
                          </div>
                        </div>
                        <div className="rowFields">
                          <Field
                            name="typeOfBusiness"
                            label="Type of Business"
                            type={type.multiSelect}
                            editable={canEditVendorData && editable()}
                            component={FieldInput}
                            className="tbRow halfRow"
                            options={setTypeOfBusiness()}
                          />
                          {valueForm &&
                          valueForm.typeOfBusiness &&
                          valueForm.typeOfBusiness.includes("Other") ? (
                            <Field
                              name="typeOfBusinessOther"
                              label="Other type"
                              type={type.text}
                              component={FieldInput}
                              className={"halfRow"}
                            />
                          ) : null}
                        </div>
                        <div className="rowFields">
                          <Field
                            name="totalValueOfCurrentProject"
                            label="Total value of current projects"
                            type={type.number}
                            editable={canEditVendorData && editable()}
                            component={FieldInput}
                          />
                          <Field
                            name="totalValueOfCurrentProjectCurrency"
                            label="Currency"
                            type={type.select}
                            loading={props.currencies.loading}
                            options={props.currencies.data}
                            editable={canEditVendorData && editable()}
                            component={FieldInput}
                          />
                        </div>
                        {/* List of Dealer */}
                        <div className="textHeader">List of Dealer</div>
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <div style={{ marginTop: "0.7rem" }} />
                          <TableData>
                            <div style={{ display: "flex" }}>
                              <div className="tbHeader" style={{ flex: 1 }}>
                                Dealer Name
                              </div>
                            </div>
                            {valueForm &&
                              valueForm.listDealer &&
                              valueForm.listDealer.map((v, i) => {
                                return (
                                  !v.deleted && (
                                    <div style={{ display: "flex" }}>
                                      <div
                                        className="tbRow"
                                        style={{ flex: 1 }}
                                      >
                                        <Field
                                          name={`listDealer[${i}].dealerName`}
                                          type={type.text}
                                          component={FieldInput}
                                          placeHolder="Dealer Name"
                                        />
                                      </div>
                                    </div>
                                  )
                                );
                              })}
                          </TableData>
                        </div>
                      </React.Fragment>
                    ) : null}
                  </React.Fragment>
                )}
              </SubDetailContainer>
              {censorData() ? null : (
                <React.Fragment>
                  {valueForm.purpose === "copy" ? null : (
                    <SubDetailContainer>
                      <div className="subTitle" style={{ marginBottom: "5px" }}>
                        {valueForm.accountGroup === "ZEMP"
                          ? "Communication"
                          : "EzProcure Registration and Communication"}
                      </div>
                      {editable() ? (
                        <React.Fragment>
                          <div className="rowFields">
                            <Field
                              name="userErrorMessage"
                              label=""
                              type={type.labelOnly}
                              component={FieldInput}
                            />
                          </div>
                          <div
                            className="rowFields"
                            style={{ marginBottom: "10px" }}
                          >
                            <Button
                              color="blue"
                              content="Add Name"
                              type="button"
                              disabled={vendorUsers.length > 4}
                              style={{ flex: 1 }}
                              onClick={() => setShowUserForm(true)}
                            />
                            <div style={{ flex: 1 }} />
                          </div>
                        </React.Fragment>
                      ) : null}
                      {valueForm.accountGroup === "ZEMP" ? null : (
                          valueForm.vendorUsers || []
                        ).filter((u) => u.registerEzProcure === true).length ===
                          0 &&
                        (valueForm.purpose === "create" ||
                          valueForm.purpose === "change") ? (
                        !editable() &&
                        (valueForm.notRegisterRemark === "" ||
                          valueForm.notRegisterRemark === undefined ||
                          valueForm.notRegisterRemark === null) ? null : (
                          <div className="rowFields">
                            <Field
                              name="notRegisterRemark"
                              label="Not Register Remark"
                              require={[
                                "ZDOV",
                                "ZFOV",
                                "ZRPT",
                                "ZRCP",
                                "ZOTV",
                              ].includes(valueForm.accountGroup)}
                              editable={editable()}
                              type={type.textArea}
                              placeHolder="กรุณาระบุเหตุผลที่ Vendor ไม่เข้าใช้งานระบบ EzProcure"
                              component={FieldInput}
                            />
                          </div>
                        )
                      ) : null}
                      {vendorUsers.length ? (
                        <ReactTable
                          data={vendorUsers}
                          columns={columnUser({
                            withActions: editable(),
                            showUserModal: showModalEditUser,
                            onDeleteUser: onDeleteUser,
                          })}
                          sortable={false}
                          pageSize={vendorUsers.length}
                          defaultPageSize={vendorUsers.length}
                          className="-striped -highlight"
                          showPagination={false}
                        />
                      ) : null}
                    </SubDetailContainer>
                  )}
                  {valueForm.purpose === "copy" ? null : (
                    <SubDetailContainer>
                      <div className="subTitle">Payment Details</div>
                      <div className="rowFields">
                        <Field
                          name="paymentType"
                          label="Payment Type"
                          type={type.labelOnly}
                          component={FieldInput}
                        />
                      </div>
                      <div className="rowFields">
                        <Field
                          name="paymentTypeTransfer"
                          label="Transfer"
                          editable={editable()}
                          type={type.checkbox}
                          component={FieldInput}
                        />
                        <Field
                          name="paymentTypeCheque"
                          label="Cheque"
                          editable={editable()}
                          type={type.checkbox}
                          component={FieldInput}
                        />
                        <Field
                          name="paymentTypeTtlc"
                          label="T/T, L/C"
                          editable={editable()}
                          type={type.checkbox}
                          component={FieldInput}
                        />
                        <Field
                          name="empty"
                          label=""
                          type={type.empty}
                          component={FieldInput}
                        />
                        <Field
                          name="empty"
                          label=""
                          type={type.empty}
                          component={FieldInput}
                        />
                        <Field
                          name="empty"
                          label=""
                          type={type.empty}
                          component={FieldInput}
                        />
                      </div>
                      {["ZDOV", "ZFIN", "ZOTV", "ZRPT", "ZRCP"].includes(
                        valueForm.accountGroup,
                      ) && valueForm.paymentTypeTransfer ? (
                        <div className="rowFields">
                          <Field
                            name="receiveEWht"
                            label="Receive E-Withholding Tax"
                            editable={editable()}
                            require={true}
                            type={type.select}
                            options={[
                              { value: true, text: "Yes" },
                              { value: false, text: "No" },
                            ]}
                            component={FieldInput}
                          />
                          <Field
                            name="empty"
                            label=""
                            type={type.empty}
                            component={FieldInput}
                          />
                        </div>
                      ) : null}
                      {editable() ? (
                        <div className="rowFields">
                          <Button
                            color="blue"
                            content="Add Bank Account"
                            type="button"
                            style={{ flex: 1 }}
                            onClick={() => setShowBankForm(true)}
                          />
                          <div style={{ flex: 1 }} />
                        </div>
                      ) : null}
                      {vendorBanks.length ? (
                        <ReactTable
                          data={vendorBanks}
                          columns={columnBank({
                            withActions: editable(),
                            showBankModal: showModalEditBank,
                            onDeleteBank: onDeleteBank,
                            countryOptions: countries.data,
                            bankKeyOptions: bankKeys.data,
                            bankBranchOptions: bankBranch,
                            getBankBranch: props.getBankBranch,
                          })}
                          sortable={false}
                          pageSize={vendorBanks.length}
                          defaultPageSize={vendorBanks.length}
                          className="-striped -highlight"
                          showPagination={false}
                        />
                      ) : null}
                    </SubDetailContainer>
                  )}
                </React.Fragment>
              )}
            </GeneralInformationContainer>
          </CardContent>
        </Collapse>
      </Card>
      {showCompanyForm ? (
        <CompanyForm
          vendorCode={valueForm.vendorCode}
          selectedCompany={valueForm.companyCode}
          companyData={valueForm.companies || []}
          showCompanyModal={setShowCompanyForm}
          onSubmitCompanies={(values) => {
            change("companies", values);
          }}
        />
      ) : null}
      {showUserForm ? (
        <EmailAndTelForm
          userData={userData}
          listUser={vendorUsers}
          accountGroup={valueForm.accountGroup}
          paymentTypeCheque={valueForm.paymentTypeCheque}
          clearUserData={setUserData}
          showVendorUserModal={setShowUserForm}
          onSubmitUser={onSubmitVendorUser}
        />
      ) : null}
      {showBankForm ? (
        <BankAccountForm
          bankData={bankData}
          listBank={vendorBanks}
          clearBankData={setBankData}
          showVendorBankModal={setShowBankForm}
          onSubmitBank={onSubmitVendorBank}
          country={valueForm.country}
        />
      ) : null}
      {showLoadVendorForm ? (
        <LoadBPForm
          onLoadBusinessPartnerSuccess={onLoadBusinessPartnerSuccess}
          onLoadBusinessPartnerWarning={onLoadBusinessPartnerWarning}
          showLoadVendorModal={setShowLoadVendorForm}
          vendorCode={valueForm.vendorCode}
          companyCode={valueForm.companyCode}
          vmId={valueForm.id}
          purpose={valueForm.purpose}
        />
      ) : null}
      {showMemberForm ? (
        <LoadTypeEForm
          onLoadMemberSuccess={onLoadTypeESuccess}
          onLoadBusinessPartnerWarning={onLoadBusinessPartnerWarning}
          showMemberModal={setShowMemberForm}
        />
      ) : null}
      <Modal open={showWarningModal}>
        <Header content="Warning!" />
        <Modal.Content>
          <p>{warningMessage}</p>
        </Modal.Content>
        <Modal.Actions>
          <Button
            color="red"
            onClick={() => {
              setShowWarningModal(false);
              setWarningMessage("");
            }}
          >
            <Icon name="remove" /> Close
          </Button>
        </Modal.Actions>
      </Modal>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    username: state.authen.user
      ? state.authen.user.username
        ? state.authen.user.username
        : ""
      : "",
    address: state.address.address,
    businessPartners: state.options.businessPartners,
    businessPartnerGroups: state.options.businessPartnerGroups,
    bankKeys: state.options.bankKeys,
    currencies: state.options.currencies,
    companies: state.options.companies,
    countries: state.options.countries,
    industries: state.options.industries,
    bankBranch: state.options.bankBranch,
    vendorCompanies: state.vendorMaintenance.vendorCompanies,
    members: state.member.members,
    memberLoading: state.member.memberLoading,
  };
};

const mapDispatchToProps = {
  getAddress,
  getBankKeys,
  getBPGroups,
  getCompanies,
  getCountry,
  getIndustries,
  getBusinessPartners,
  getBankBranch,
  showConfirmModal,
  getBPCompanies,
  getBPAccountingView,
  getHrmsMembers,
  getBPGeneralView,
  getAllMembers,
};

export default connect(mapStateToProps, mapDispatchToProps)(GeneralInformation);
